exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnswerItem__AnswerItem--EBjj_{\r\n    border:1px solid #fff;\r\n    border-radius: 5px;\r\n    padding: 5px 10px;\r\n    margin-bottom: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.AnswerItem__AnswerItem--EBjj_:hover{\r\n    background-color: rgba(255,255,255,0.2);\r\n    transition: all .5s ease-in-out;\r\n}\r\n\r\n.AnswerItem__AnswerItem--EBjj_.AnswerItem__success--1aPLY {\r\n    background: rgba(161, 240, 69, .7);\r\n}\r\n\r\n.AnswerItem__AnswerItem--EBjj_.AnswerItem__error--1JXsA {\r\n    background: rgba(240, 87, 108, .7);\r\n}", ""]);

// exports
exports.locals = {
	"AnswerItem": "AnswerItem__AnswerItem--EBjj_",
	"success": "AnswerItem__success--1aPLY",
	"error": "AnswerItem__error--1JXsA"
};